import React, {useState} from 'react';
import {TouchableWithoutFeedback, View} from "react-native";
import {TranslationView} from "@levelapp/softfabric-ui";
import {clearToken} from "../../../../../../../Common/Utils/token.utils";
import {styles} from "./LogOutButtonViewStyle";

interface LogOutButtonViewProps {
    isVisible: boolean;
    divStyle: any;
    setToken: (token: string | undefined) => void;
}

export default function LogOutButtonView({isVisible, divStyle, setToken}: LogOutButtonViewProps) {
    const [isHovered, setIsHovered] = useState(false);

    const visibleHrefStyle = isHovered ? styles.buttonHover : styles.buttonDefault;

    function onLogoutPress() {
        clearToken();
        setToken(undefined);
    }

    return isVisible ? (
        <TouchableWithoutFeedback
            onPressIn={() => setIsHovered(true)}
            onPressOut={() => setIsHovered(false)}
            onPress={onLogoutPress}
        >
            <View style={[styles.button, visibleHrefStyle, {paddingVertical: 3}]}>
                <TranslationView
                    style={[styles.buttonText, isHovered ? styles.buttonTextHover : styles.buttonTextDefault]}>logout</TranslationView>
            </View>
        </TouchableWithoutFeedback>
    ) : (
        <TouchableWithoutFeedback
            onPress={onLogoutPress}
        >
            <View style={[styles.buttonDefault, divStyle]}>
                <TranslationView style={styles.buttonTextMobile}>logout</TranslationView>
            </View>
        </TouchableWithoutFeedback>
    );
}